/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["img[_ngcontent-%COMP%]{max-width:100%}.mat-tab-label[_ngcontent-%COMP%], .mat-tab-link[_ngcontent-%COMP%]{margin-bottom:16px;font-size:18px;color:#212428;letter-spacing:.58px;position:relative;text-transform:uppercase;line-height:1;padding-left:.5em;font-weight:900}.mat-tab-group.mat-primary[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-primary[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%]{background-color:#d32d2d}[_nghost-%COMP%]     .mat-drawer-container{background-color:#fafafa;color:#000}"];
export { styles as styles };
